import React, { useState } from 'react';

import { Toast as BootstrapToast } from 'react-bootstrap';

export interface ToastMessage {
  id: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  title: string;
  description?: string;
}

interface ToastProps {
  message: ToastMessage;
}

const Toast: React.FC<ToastProps> = ({ message }): React.ReactElement => {
  const [show, setShow] = useState(true);
  return (
    <BootstrapToast
      onClose={() => setShow(false)}
      show={show}
      delay={5000}
      autohide
      className={`bg-${message.type === 'error' ? 'danger' : message.type}`}
    >
      <BootstrapToast.Header>
        <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
        <strong className="me-auto">{message.title}</strong>
      </BootstrapToast.Header>
      <BootstrapToast.Body className="text-white">
        {message.description ? message.description : message.title}
      </BootstrapToast.Body>
    </BootstrapToast>
  );
};

export default Toast;
